export default __webpack_public_path__ + "static/media/corner1.b48a9b2a.png";